import React from "react";
import { useHistory } from "react-router-dom";

export const EstadoResultadoItem = ( {data, permisos} ) => {
  const history = useHistory();
  const GetClass = (value, minimo = 20, medium = 81) => {
    if (value <= minimo) return "circle-red";
    else if (value <= medium) return "circle-yellow";
    else return "circle-success";
  };
  const handleClickEstadoResultado = () => {
    history.push("/Finanzas/EstadodeResultados", permisos);
  };

  const ventasnetas = data?.estadoresultadoreal?.ventaneta;
  const costos = data?.estadoresultadoreal?.costos;
  const utilidadbruta = data?.estadoresultadoreal?.utilidadbruta;
  const gastosdepartamentales = data?.estadoresultadoreal?.gastosdepartamentales;
  const gastosadministracion = data?.estadoresultadoreal?.gastosadministracion;
  const gastosstaff = data?.estadoresultadoreal?.gastosstaff;
  const gastosfinanzas = data?.estadoresultadoreal?.gastosfinanzas;
  const utilidadoperacion = data?.estadoresultadoreal?.utilidadoperacion;
  const ventasnetasproyectadas = data?.estadoresultadoreal?.ventanetaproyectada;
  const costosproyectados = data?.estadoresultadoreal?.costosproyectados;
  const utilidadbrutaproyectada = data?.estadoresultadoreal?.utlidadbrutaproyectada;
  const gastosdepartamentalesproyectados = data?.estadoresultadoreal?.gastosdepartamentalesproyectados;
  const gastosadministracionproyectados = data?.estadoresultadoreal?.gastosadministracionproyectados;
  const gastosstaffproyectados = data?.estadoresultadoreal?.gastosstaffproyectados;
  const gastosfinanzasproyectados = data?.estadoresultadoreal?.gastosfinanzasproyectados;
  const utilidadoperacionproyectada = data?.estadoresultadoreal?.utilidadoperacionproyectada;

  const formatmiles = (number) => {
    return Math.floor((number ?? 0) / 1000).toLocaleString('en-US');
};

const calcularporcentaje = (param, ventasNetas) => {
  if (!ventasNetas) return 0;
  return ((param / ventasNetas) * 100).toFixed(2);
};

  return (
    <div className="dashboard-financiero-container-box" onClick={handleClickEstadoResultado}>
      <div className="dashboard-financiero-container-box-titulo">
        Estado de Resultados
      </div>
      <div className="dashboard-financiero-container-box-info df_box_estado_resultados scroll-4">
        <table cellPadding={0} cellSpacing={0}>
          <tbody>
            <tr className="fw-bold">
              <td>Ventas Netas</td>
              <td>{formatmiles(ventasnetas)}</td>
              <td>100 %</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <span>-</span> Costos de Venta
              </td>
              <td>{formatmiles(costos)}</td>
              <td>{calcularporcentaje(costos, ventasnetas)} %</td>
              <td>
                <div className={GetClass(80)}></div>
              </td>
            </tr>
            <tr className="fw-bold">
              <td>
                <span>=</span> Utilidad Bruta
              </td>
              <td>{formatmiles(utilidadbruta)}</td>
              <td>{calcularporcentaje(utilidadbruta, ventasnetas)} %</td>
              <td>
                <div className={GetClass(20)}></div>
              </td>
            </tr>
            <tr>
              <td>
                <span>-</span> Gastos Departamentales
              </td>
              <td>{formatmiles(gastosdepartamentales)}</td>
              <td>{calcularporcentaje(gastosdepartamentales, ventasnetas)} %</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <span>-</span> Gastos Administracion
              </td>
              <td>{formatmiles(gastosadministracion)}</td>
              <td>{calcularporcentaje(gastosadministracion, ventasnetas)} %</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <span>-</span> Gastos Staff
              </td>
              <td>{formatmiles(gastosstaff)}</td>
              <td>{calcularporcentaje(gastosstaff, ventasnetas)} %</td>
              <td></td>
            </tr>
            <tr>
              <td>
                <span>-</span> Gastos Finanzas
              </td>
              <td>{formatmiles(gastosfinanzas)}</td>
              <td>{calcularporcentaje(gastosfinanzas, ventasnetas)} %</td>
              <td></td>
            </tr>
            <tr className="fw-bold">
              <td>
                <span>=</span> Utilidad de Operación
              </td>
              <td>{formatmiles(utilidadoperacion)}</td>
              <td>{calcularporcentaje(utilidadoperacion, ventasnetas)} %</td>
              <td>
                <div className={GetClass(1.95)}></div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};
